module.exports = __webpack_public_path__ + "static/media/Page_30_Fashion-Portfolio.4b981c8c.jpg";